import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import GenericList from "../components/GenericList";
import Loader from "../components/Loader";
import moment from "moment-timezone";
import { Switch, FormControlLabel } from "@mui/material";
import { ACTION_BUTTONS, USERID } from "../config/constants";
import { COLORS } from "../config/theme";
import { notification, Modal as ModalAntd, Card } from "antd";
import {
  obtenerNotificacionesNoLeidasPorExpediente,
  obtenerMensajesNoLeidosPorExpediente,
  marcarComoLeido,
} from "../services/sms.service";
import {
  obtenerExpedientes,
  eliminarExpediente,
  compartirExpediente,
  reabrirExpediente,
  descargarArchivosExpediente
} from "../services/expediente.service"; // Importar eliminarExpediente
import { obtenerAccesosPorUsuario } from "../services/access.service";
import { Grid, Typography } from "@mui/material";
import Modal from "../components/Modal";
import ResponderMensaje from "../components/ResponderMensaje";
import { STRINGS } from "../dictionaries/ESP.dictionary";
import { ExpedienteForm } from "../components/ExpedienteForm";
import { Tooltip, Progress } from "antd";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import { Badge, IconButton } from "@mui/material";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import SelectorDeUsuarioParaCompartir from "../components/SelectorDeUsuarioParaCompartir";
import ReplyOutlinedIcon from '@mui/icons-material/ReplyOutlined';
import { ACCESOS } from "../config/constants";
const argentinaTimezone = "America/Argentina/Buenos_Aires";

moment.tz.setDefault(argentinaTimezone);

const Home = () => {
  const [proceduresList, setProceduresList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [reload, setReload] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const { confirm } = ModalAntd;
  const currentUserid = localStorage.getItem(USERID);
  const [currentPage, setCurrentPage] = useState(1); // Corrected state name
  const [currentPageSize, setCurrentPageSize] = useState(10); // Corrected state name
  const [orderByField, setOrderByField] = useState("id_expediente");
  const [orderByDirection, setOrderByDirection] = useState("asc");
  const [modalWidth, setModalWidth] = useState("500px");
  const navigate = useNavigate();
  const { Meta } = Card;
  const { Text } = Typography;
  const [accesosUsuario, setAccesosUsuario] = useState(null);
  const [accesoCrearExpediente, setAccesoCrearExpediente] = useState(false);
  const [accesoEditarExpediente, setAccesoEditarExpediente] = useState(false);
  const [accesoCompartirConExpediente, setAccesoCompartirConExpediente] =
    useState(false);
  const [accesoEliminarExpediente, setAccesiEliminarExpediente] =
    useState(false);
  const [listActionButtons, setListActionButtons] = useState([]);
  const [incluirFinalizados, setIncluirFinalizados] = useState(false);

  // const listActionButtons = [ACTION_BUTTONS.EDIT,  ACTION_BUTTONS.SHAREWITH, ACTION_BUTTONS.DELETE];

  const markAsRead = async (id, id_expediente) => {
    const sms = await marcarComoLeido(id);
    showNotifications(id_expediente);
  };

  const showNotifications = async (id_expediente) => {
    const sms = await obtenerNotificacionesNoLeidasPorExpediente(id_expediente);
    setModalTitle("NOTIFICACIONES NO LEÍDAS");

    const content = (
      <div>
        <Grid container spacing={2}>
          {sms.data.length > 0 ? (
            sms.data.map((mensaje, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <Card
                  style={{
                    minHeight: "200px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Sombra sutil
                    borderRadius: "10px", // Bordes redondeados para darle un mejor aspecto
                  }}
                  actions={[
                    <div
                      key="read"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        markAsRead(mensaje.id, id_expediente);
                      }}
                    >
                      <MarkEmailReadOutlinedIcon style={{ fontSize: 26 }} />
                      <Typography variant="caption" style={{ fontSize: "12px" }}>
                        Marcar como leído
                      </Typography>
                    </div>,
                    mensaje.conversa === 1 && (
                      <div
                        key="reply"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          responder(mensaje.id, mensaje.mensaje);
                        }}
                      >
                        <ReplyOutlinedIcon style={{ fontSize: 26 }} />
                        <Typography variant="caption" style={{ fontSize: "12px" }}>
                          Responder
                        </Typography>
                      </div>
                    ),
                  ]}
                >
                  <Grid container>
                    <Grid item xs={12}>
                      <Typography variant="h6">{mensaje.titulo}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        style={{
                          minHeight: "70px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {mensaje.mensaje}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        key="user"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginRight: "8px",
                        }}
                      >
                        <PersonOutlinedIcon /> {mensaje.usu_origen}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        key="date"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <CalendarMonthOutlinedIcon />{" "}
                        {moment(mensaje.fecha_env).format("DD/MM/YYYY HH:mm")}
                      </Typography>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            ))
          ) : (
            <>
              <Grid
                item
                xs={12}
                sm={12}
                style={{
                  minHeight: "50vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <InboxOutlinedIcon style={{ fontSize: 80, color: "#ccc" }} />
                <p style={{ textAlign: "center" }}>No tenes mensajes sin leer</p>
              </Grid>
            </>
          )}
        </Grid>
      </div>
    );
    
    setModalContent(content);
    setModalWidth("800px");
    setIsVisibleModal(true);
  };

  const showMensajes = async (id_expediente) => {
    const sms = await obtenerMensajesNoLeidosPorExpediente(id_expediente);
    setModalTitle("MENSAJES NO LEÍDOS");

    const content = (
      <div>
        <Grid container spacing={2}>
          {sms.data.length > 0 ? (
            sms.data.map((mensaje, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <Card
                  style={{
                    minHeight: "200px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Sombra sutil
                    borderRadius: "10px", // Bordes redondeados para darle un mejor aspecto
                  }}
                  actions={[
                    <div
                      key="read"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        markAsRead(mensaje.id, id_expediente);
                      }}
                    >
                      <MarkEmailReadOutlinedIcon style={{ fontSize: 26 }} />
                      <Typography variant="caption" style={{ fontSize: "12px" }}>
                        Marcar como leído
                      </Typography>
                    </div>,
                    mensaje.conversa === 1 && (
                      <div
                        key="reply"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          responder(mensaje.id, mensaje.mensaje);
                        }}
                      >
                        <ReplyOutlinedIcon style={{ fontSize: 26 }} />
                        <Typography variant="caption" style={{ fontSize: "12px" }}>
                          Responder
                        </Typography>
                      </div>
                    ),
                  ]}
                >
                  <Grid container>
                    <Grid item xs={12}>
                      <Typography variant="h6">{mensaje.titulo}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        style={{
                          minHeight: "70px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {mensaje.mensaje}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        key="user"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginRight: "8px",
                        }}
                      >
                        <PersonOutlinedIcon /> {mensaje.usu_origen}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        key="date"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <CalendarMonthOutlinedIcon />{" "}
                        {moment(mensaje.fecha_env).format("DD/MM/YYYY HH:mm")}
                      </Typography>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            ))
          ) : (
            <>
              <Grid
                item
                xs={12}
                sm={12}
                style={{
                  minHeight: "50vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <InboxOutlinedIcon style={{ fontSize: 80, color: "#ccc" }} />
                <p style={{ textAlign: "center" }}>No tenes mensajes sin leer</p>
              </Grid>
            </>
          )}
        </Grid>
      </div>
    );
    
    setModalContent(content);
    setModalWidth("800px");
    setIsVisibleModal(true);
  };  

    const responder = (id, mensaje) => {
      console.log("Respondiendo al mensaje con ID:", id);
      setIsVisibleModal(true);
      setModalTitle("Responder mensaje");
      setModalContent(
        <ResponderMensaje
          setReload={setReload}
          reload={reload}
          setIsVisibleModal={setIsVisibleModal}
          mensaje={mensaje}
          respuesta={id}
        />
      );
    };

    const listColumns = [
      { title: "ID", field: "id_expediente", width: "10px" },
      { title: "TIPO", field: "tramite_nombre" },
      {
        title: "AVANCE",
        field: "total_requisitos",
        width: "30px",
        render: (row) => {
          const { total_requisitos, requisitos_completados } = row;
          const porcentaje = total_requisitos
            ? (requisitos_completados / total_requisitos) * 100
            : 0;
          const tooltipText = `${requisitos_completados}/${total_requisitos} requisitos completados`;
    
          return (
            <Tooltip title={tooltipText}>
              <Progress
                percent={Math.round(porcentaje)}
                status={porcentaje === 100 ? "success" : "active"}
              />
            </Tooltip>
          );
        },
      },
      { title: "PROFESIONAL", field: "usuario_alta", width: "30px" },
      // { title: "OFICINA", field: "oficina_nombre", width: "30px" },
      {
        title: "NOMENCLATURA",
        field: "circ",
        width: "30%", // Ajusta el ancho
        render: (row) => {
          const items = [];
      
          // Verifica si hay datos y agrega el label+valor
          if (row?.circ) items.push(<span>CIRC: <b>{row?.circ}</b></span>);
          if (row?.secc) items.push(<span>SECC: <b>{row?.secc}</b></span>);
          if (row?.fr_nro) items.push(<span>FrN: <b>{row?.fr_nro}</b></span>);
          if (row?.fr_lt) items.push(<span>FrL: <b>{row?.fr_lt}</b></span>);
          if (row?.q_nro) items.push(<span>QuN: <b>{row?.q_nro}</b></span>);
          if (row?.q_lt) items.push(<span>QuL: <b>{row?.q_lt}</b></span>);
          if (row?.ch_nro) items.push(<span>ChN: <b>{row?.ch_nro}</b></span>);
          if (row?.ch_lt) items.push(<span>ChL: <b>{row?.ch_lt}</b></span>);
          if (row?.mz_nro) items.push(<span>MzN: <b>{row?.mz_nro}</b></span>);
          if (row?.mz_lt) items.push(<span>MzL: <b>{row?.mz_lt}</b></span>);
          if (row?.p_nro) items.push(<span>ParcN: <b>{row?.p_nro}</b></span>);
          if (row?.p_lt) items.push(<span>ParcL: <b>{row?.p_lt}</b></span>);
          if (row?.sp_nro) items.push(<span>SubpN: <b>{row?.sp_nro}</b></span>);
          if (row?.sp_lt) items.push(<span>SubpL: <b>{row?.sp_lt}</b></span>);
      
          // Utiliza el método map para agregar los separadores " | " entre los elementos
          return (
            <span>
              {items.map((item, index) => (
                <span key={index}>
                  {item}
                  {index < items.length - 1 && " | "}
                </span>
              ))}
            </span>
          );
        }
      },   
      { title: "PARTIDA", field: "partida", width: "8%" },   
      {
        title: "DOMICILIO",
        field: "dir_calle",
        render: (row) => (
          <span>{`${row?.dir_calle} ${row?.dir_nro}, ${row?.dir_loc}`}</span>
        ),
        width: "200px", // Ajustar según lo necesario
      },
      {
        title: <Tooltip title="Notificaciones"></Tooltip>,
        field: "notificaciones_pendientes",
        width: "30px",
        render: (row) => {
          const { notificaciones_pendientes } = row;
    
          // Solo mostrar el badge si hay notificaciones pendientes
          const badgeContent =
            notificaciones_pendientes > 0 ? notificaciones_pendientes : null;
    
          return (
            <Tooltip
              title={`${notificaciones_pendientes} notificaciones sin leer`}
            >
              <IconButton onClick={() => showNotifications(row.id_expediente)}>
                <Badge
                  badgeContent={badgeContent}
                  color="error" // Color rojo
                  sx={{
                    "& .MuiBadge-dot": {
                      borderRadius: "50%", // Bordes redondeados
                      width: "12px", // Tamaño del badge
                      height: "12px",
                      backgroundColor: "red", // Color de fondo del badge
                    },
                    "& .MuiBadge-content": {
                      color: "white", // Color del texto dentro del badge
                    },
                  }}
                >
                  <NotificationsIcon />
                </Badge>
              </IconButton>
            </Tooltip>
          );
        },
      },
      {
        title: <Tooltip title="Mensajes"></Tooltip>,
        field: "mensajes_pendientes",
        width: "30px",
        render: (row) => {
          const { mensajes_pendientes } = row;
    
          // Solo mostrar el badge si hay mensajes pendientes
          const badgeContent =
            mensajes_pendientes > 0 ? mensajes_pendientes : null;
    
          return (
            <Tooltip title={`${mensajes_pendientes} mensajes sin leer`}>
              <IconButton onClick={() => showMensajes(row.id_expediente)}>
                <Badge
                  badgeContent={badgeContent}
                  color="error" // Color rojo
                  sx={{
                    "& .MuiBadge-dot": {
                      borderRadius: "50%", // Bordes redondeados
                      width: "12px", // Tamaño del badge
                      height: "12px",
                      backgroundColor: "red", // Color de fondo del badge
                    },
                    "& .MuiBadge-content": {
                      color: "white", // Color del texto dentro del badge
                    },
                  }}
                >
                  <ChatBubbleOutlineOutlinedIcon />
                </Badge>
              </IconButton>
            </Tooltip>
          );
        },
      },
    ];
    

  const detailPanel = (data) => {
    const expediente = data;

    return (
      <div style={{ fontSize: "1rem" }}>
        <table
          style={{
            border: "1px solid #ccc",
            borderCollapse: "collapse",
            width: "100%",
            marginLeft: "1rem",
            fontSize: "1rem",
          }}
        >
          <thead>
            <tr style={{ background: "#f2f2f2", fontSize: "1rem" }}>
              <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  width: "15%",
                }}
              >
                PLANO ANTECEDENTE
              </th>
              <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  width: "15%",
                }}
              >
                ZONIFICACIÓN
              </th>
              <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  width: "15%",
                }}
              >
                SUPERFICIE PARCELA
              </th>
              <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  width: "15%",
                }}
              >
                FOS
              </th>
              <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  width: "15%",
                }}
              >
                FOT
              </th>
              <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  width: "70%",
                }}
              >
                OBSERVACIONES
              </th>
            </tr>
          </thead>
          <tbody>
            <tr key={expediente.id_expediente}>
              <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                {expediente?.plano_antecedente}
              </td>
              <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                {expediente?.zonificacion}
              </td>
              <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                {expediente.superficie_parcela}m²
              </td>
              <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                {expediente.fos}
              </td>
              <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                {expediente.fot}
              </td>
              <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                {expediente.obs}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  const onCreateAction = () => {
    setModalTitle("NUEVO EXPEDIENTE");
    setModalWidth("700px");
    setModalContent(
      <ExpedienteForm
        setIsVisibleModal={setIsVisibleModal}
        setReload={setReload}
        reload={reload}
      />
    );
    setIsVisibleModal(true);
  };

  const compartirConUsuarios = async (users, id_expediente) => {
    const compartidos = await compartirExpediente(users, id_expediente);
    console.log(compartidos);
    setReload(!reload);
  };

  const compartirConAction = (row) => {
    setModalTitle("COMPARTIR EXPEDIENTE");
    setModalContent(
      <SelectorDeUsuarioParaCompartir
        setIsVisibleModal={setIsVisibleModal}
        setReload={setReload}
        reload={reload}
        id_expediente={row.id_expediente}
        callback={compartirConUsuarios}
      />
    );
    setIsVisibleModal(true);
  };

  const onEditAction = (rowData) => {
    console.log("Edición de expediente", rowData);
    navigate(`/expediente/${rowData.id_expediente}`);
  };


  const onReopen = async (rowData) => {
    if(rowData.id_estado !== 3){
      notification.warning({
        message: "Expediente abierto",
        description: `El expediente ${rowData.id_expediente} ya se encuentra abierto.`,
      });
      return;
    }
    const reabierto = await reabrirExpediente(rowData.id_expediente);
    console.log(reabierto);
    notification.success({
      message: "Expediente reabierto",
      description: `El expediente ${rowData.id_expediente} fué reabierto.`,
    });
    setReload(!reload);
  };

  const onDownloadAction = async (rowData) => {
    setIsLoading(true);
    try {
      await descargarArchivosExpediente(rowData.id_expediente);
      notification.success({
        message: "Paquete de archivos generado correctamente",
      });
    } catch (error) {
      if (error.message === "NO_ARCHIVOS") {
        notification.warning({
          message: "No se encontraron archivos en el expediente",
        });
      } else {
        console.error(error);
        notification.error({
          message: "Error generando paquete de archivos de expediente",
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const onDeleteAction = (rowData) => {
    console.log("onDeleteAction", rowData);

    confirm({
      title: "Eliminar expediente",
      content: `¿Estás seguro que desea eliminar el expediente?`,
      okText: "Eliminar",
      okType: "primary",
      cancelText: "Cancelar",
      async onOk() {
        try {
          await eliminarExpediente(rowData.id_expediente); // Implementar eliminarExpediente
          notification["success"]({
            message: "Expediente eliminado correctamente",
          });
          setReload(!reload);
        } catch (error) {
          notification["error"]({
            message: "Error eliminando el expediente",
          });
        }
      },
    });
  };

  const fetchExpedientes = async (currentUserid) => {
    setIsLoading(true);
    try {
      const results = await obtenerExpedientes(
        currentUserid,
        currentPageSize,
        currentPage,
        orderByField,
        orderByDirection,
        incluirFinalizados
      );

      if (results?.data?.data?.length > 0) {
        const dataWithIds = results?.data.data.map((item) => ({
          ...item,
          id: item.id_expediente, // Asignar id único basado en id_expediente
        }));
        console.log(dataWithIds);
        setProceduresList(dataWithIds);
      }
    } catch (error) {
      console.log("Error al obtener expedientes:", error);
      notification["error"]({
        message:
          error?.reponse?.data.message ||
          "Error al obtener la lista de expedientes",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (currentUserid) {
      fetchExpedientes(currentUserid);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload, currentUserid, currentPageSize, incluirFinalizados]);

  useEffect(() => {
    const fetchAccesos = async () => {
      try {
        const response = await obtenerAccesosPorUsuario(currentUserid);

        // Verificar si el usuario tiene los permisos necesarios
        const accAlta = response.data.data?.some(
          (acceso) =>
            acceso.acceso.trim().toUpperCase() === ACCESOS.TRAMITE_ALTA
        );
        setAccesoCrearExpediente(accAlta);
        const accEdi = response.data.data?.some(
          (acceso) =>
            acceso.acceso.trim().toUpperCase() === ACCESOS.TRAMITE_MODIFICACION
        );
        const accCompa = response.data.data?.some(
          (acceso) =>
            acceso.acceso.trim().toUpperCase() === ACCESOS.TRAMITE_COMPARTIR
        );
        const accEli = response.data.data?.some(
          (acceso) =>
            acceso.acceso.trim().toUpperCase() === ACCESOS.TRAMITE_ELIMINAR
        );
        const accVer = response.data.data?.some(
          (acceso) =>
            acceso.acceso.trim().toUpperCase() === ACCESOS.TRAMITE_VER_DETALLE
        );
        const accReabrir = response.data.data?.some(
          (acceso) =>
            acceso.acceso.trim().toUpperCase() === ACCESOS.TRAMITE_REABRIR
        );
        const accDescargar = response.data.data?.some(
          (acceso) =>
            acceso.acceso.trim().toUpperCase() === ACCESOS.TRAMITE_DESCARGAR
        );


        setListActionButtons([]);
        if (accEdi) {
          setListActionButtons((lista) => [...lista, ACTION_BUTTONS.EDIT]);
        }

        if (accCompa) {
          setListActionButtons((lista) => [...lista, ACTION_BUTTONS.SHAREWITH]);
        }

        if (accEli) {
          setListActionButtons((lista) => [...lista, ACTION_BUTTONS.DELETE]);
        }
        if (accVer) {
          setListActionButtons((lista) => [
            ...lista,
            ACTION_BUTTONS.VIEWDETAIL,
          ]);
        }
        if(accReabrir){
          setListActionButtons((lista) => [
            ...lista,
            ACTION_BUTTONS.REOPEN,
          ]);
        }
        if(accDescargar){
          setListActionButtons((lista) => [
            ...lista,
            ACTION_BUTTONS.DOWNLOAD,
          ]);
        }
      } catch (error) {
        console.error("Error al obtener accesos del usuario", error);
      }
    };

    fetchAccesos();
  }, []);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="mainContentContainer">
          <div
            style={{ paddingLeft: 10, marginBottom: "15px", marginTop: "20px" }}
          >
            <FormControlLabel
              control={
                <Switch
                  checked={incluirFinalizados}
                  onChange={(e) => setIncluirFinalizados(e.target.checked)}
                  color="primary" // Puedes cambiar el color si deseas
                />
              }
              label="Incluir finalizados"
            />
          </div>
          <GenericList
            columns={listColumns}
            addDisabled={!accesoCrearExpediente}
            data={proceduresList}
            actions={listActionButtons}
            onCreateButtonClick={onCreateAction}
            onEditAction={onEditAction}
            onViewDetail={onEditAction}
            onDeleteAction={onDeleteAction}
            onShareWithAction={compartirConAction}
            onDownloadAction={onDownloadAction}
            onReopen={onReopen}
            COLORS={COLORS}
            title={STRINGS.MY_PROCEDURE.toUpperCase()}
            detailPanel={detailPanel}
            onPageChange={(page) => {
              console.log("Current page", page + 1);
              setCurrentPage(page + 1);
            }}
            onPageSizeChange={(pageSize) => {
              console.log("Page size", pageSize);
              setCurrentPageSize(pageSize);
            }}
            onOrderChange={(order) => {
              console.log("New order", order[0]);
              setOrderByField(order[0]?.orderByField);
              setOrderByDirection(order[0]?.orderDirection);
              setReload(!reload);
            }}
            actionVisible={(action, row) => {
              if (action === ACTION_BUTTONS.REOPEN) {
                return row.id_tramite === 3;
              }
              return true;
            }}
          />
        </div>
      )}
      <Modal
        title={modalTitle}
        open={isVisibleModal}
        width={modalWidth}
        setIsVisible={setIsVisibleModal}
      >
        {modalContent}
      </Modal>
    </>
  );
};

export default Home;
